export default {"src":"/_next/static/media/our_mission.b53f920d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};